import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { CancelToken } from "axios";

import api from "../common/api";
import FiveStarComponent from "../common/FiveStarComponent";
import Searchbar from "../result/Searchbar";

import { ReactComponent as StarSvg } from "../logo/Star.svg";

import "./PoiPage.css";
import { AddToBucketListButton } from "./AddToBucketListButton";
import { AddToCartButton } from "./AddToCartButton";

export function PoiPage(props) {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [poi, setPoi] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const source = CancelToken.source();
    async function fetchData() {
      try {
        const res = await api.get(`/api/poi-details/${id}/`, {
            cancelToken: source.cancelToken
        });
        await setPoi(res.data);
      } catch (e) {
        setError(e);
      }
      setIsLoading(false);
    }
    fetchData();
    return () => {
        source.cancel();
    }
  }, [id]);

  return (
    <div className="poi-page">
      <Searchbar shouldPushHistory={true} initialKeyword={""} />
      {isLoading && (
        <div className="d-flex justify-content-center align-self-center w-100">
          <div className="spinner-border" role="status" />
        </div>
      )}
      {!isLoading && error && (
        <div className="d-flex justify-content-center align-self-center w-100">
          {error}
        </div>
      )}
      {!isLoading && !error && <PoiDetailComponent poi={poi} />}
    </div>
  );
}

function PoiDetailComponent(props) {
  const { poi } = props;
  const { rating } = poi;
  console.log(poi);
  return (
    <>
      <div className="d-flex justify-content-between align-items-start flex-column flex-lg-row">
        <div className="poi-headers-details">
          <CategoryLabel category={poi.category} />
          <div className="poi-title">
            <h3 className="poi-name">{poi.name}</h3>
            <div className="poi-title-rating">
              <StarSvg />
              <div>{rating.rating}</div>
            </div>
          </div>
          <div className="subhead">{poi.city}</div>
          <PriceLabel min={poi.min_spending} max={poi.max_spending} />
        </div>
        <div className="poi-actions d-flex">
          <AddToBucketListButton poiId={poi.id} />
          <AddToCartButton {...poi} />
        </div>
      </div>
      <div className="divider" />
      <img className="poi-image" src={poi.image_url} alt={poi.name} />
      <div className="poi-center-details">
        <PoiDescription description={poi.description} />

        {/* TODO: pass correct variables from POI once review rating and data are available */}
        <PoiReviewSection rating={poi.rating} review={poi.review}/>
      </div>
    </>
  );
}

function PoiDescription(props) {
  const { description } = props;
  return (
    <div className="poi-description">
      <div className="headline">Deskripsi Destinasi Wisata</div>
      <div>{description || "-"}</div>
    </div>
  );
}

function PoiIndividualReview(props) {
  const reviewRating = props.rating;
  const review = props.review;
  const source = props.source;
  return (
    <div className="individual-review-container">
      <FiveStarComponent value={reviewRating} editable={false} />
      <div className="review-content">{review}</div>
      <div className="review-source">
        <span>Source: </span>
        <img src={source} alt="review-source" />
      </div>
    </div>
  );
}

function PoiReviewSection(props) {
  // TODO: Change reviews variable to actual review data once available
    
  const reviews = props.review
  return (
    <div className="poi-review-section">
      <div className="headline">Peringkat & Ulasan</div>
      <div className="rating-aggregate headline">
        <StarSvg/>
        <span>{`${props.rating.rating} dari 5`}</span>
      </div>
      <div className="divider" />
      <div className="semua-ulasan">Semua Ulasan</div>
      {reviews.map((review, i) => {
        return (
          <div key={i}>
            <PoiIndividualReview {...review} />
            {i !== reviews.length && <div className="divider" />}
          </div>
        );
      })}
    </div>
  );
}

function PriceLabel(props) {
  const { min, max } = props;
  const idrFormatter = new Intl.NumberFormat("id", {
    style: "currency",
    currency: "IDR",
  });
  let prices = [];
  if (!!min) prices.push(min);
  if (!!max) prices.push(max);
  prices = prices.map((price) => idrFormatter.format(price));

  let priceString = prices.join(" - ");
  return <div>{`Harga Tiket: ${priceString}`}</div>;
}

function CategoryLabel(props) {
  const { category } = props;
  return (
    <div className="d-flex flex-row">
      <div className="category d-inline-flex">
        <h5 data-testid="poi-category" className="category-title">
          {category}
        </h5>
      </div>
    </div>
  );
}

export default PoiPage;
